import type { WhitelabelConfig as gqlWhitelabelConfig } from '@/generated/graphql';
import * as Attachment from '@/types/Attachment';

import { take } from '@/helpers/takePayload';

export interface WhitelabelConfig {
  id?: number;
  domain?: string;
  name?: string;
  url?: string;
  landingUrl?: string;
  fromEmail?: string;
  stripeApiKey?: string;
  stripePublishableKey?: string;
  attachment?: Attachment.Attachment;
}

export const getNew = (): WhitelabelConfig => ({
  name: '',
  domain: '',
  url: '',
  stripeApiKey: '',
});

export const fromGql = (gqlWhitelabelConfig: gqlWhitelabelConfig): WhitelabelConfig => ({
  ...(take(
    gqlWhitelabelConfig,
    'id',
    'domain',
    'name',
    'landingUrl',
    'stripeApiKey',
    'stripePublishableKey',
    'fromEmail',
  ) as WhitelabelConfig),
  attachment: gqlWhitelabelConfig.attachment ? Attachment.fromGql(gqlWhitelabelConfig.attachment) : undefined,
});
